import { render, staticRenderFns } from "./DocumentsUpdateModal.vue?vue&type=template&id=4437ad2d&"
import script from "./DocumentsUpdateModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsUpdateModal.vue?vue&type=style&index=0&id=4437ad2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports